import { TableColumn } from "react-data-table-component";
import { Badges, Btn } from "../../AbstractElements";
import { CustomCellInterFace } from "../../Types/TablesType";

//Services
import {
  COMPANY_JOBS_QUERY_KEY,
  VIEW_COMPANY_JOBS_QUERY_KEY,
  companyjobTitleService,
} from "../../Services/companyjobtitleService";

//Types
import { ViewCompanyJobs } from "../../Types/CompanyProfile/CompanyJobs";

const CustomBadge: React.FC<CustomCellInterFace> = ({ label, color }) => (
  <Badges pill color={color}>
    {label}
  </Badges>
);

export const StructureTableColumn: TableColumn<ViewCompanyJobs>[] = [
  {
    name: "JOB TITLE",
    selector: (row) => row.job_title,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{`${row.job_title}`}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "JOB LEVEL",
    selector: (row) => row.job_title,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{`${row.level_name}`}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "SALARY RANGE",
    selector: (row) => row.job_title,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.min_salary_formatted && row.max_salary_formatted
          ? `${row.min_salary_formatted} - ${row.max_salary_formatted}`
          : ""}
      </div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    width: "180px",
    sortable: true,
    center: false,
  },
];
